
export default {
  emits: ['openVacancyPopup'],
  props: {
    vacancy: {
      type: Object,
      require: false,
    },
    // title: {
    //   type: String,
    //   required: false,
    // },
    // salary: {
    //   type: String,
    //   required: false,
    // },
    // announce: {
    //   type: String,
    //   required: false,
    // },
    // description: {
    //   type: String,
    //   required: false,
    // },
  },
  methods: {
    openPopup() {
      this.$emit('openVacancyPopup', this.vacancy)
    },
  },
}
